import { LabelsModeled } from '../types/LabelsModeled';

export const getLabelsByLanguage = (language: string, labels: LabelsModeled[]): LabelsModeled => {
  return labels?.find((labelByLanguage) => {
    const languageKey = Object.keys(labelByLanguage);
    return languageKey[0] === language;
  });
};
